import { SolicitarCancelamento } from "./SolicitarCancelamento";

export default SolicitarCancelamento;